import React, { useCallback, useMemo } from 'react';
import { Box, PriceInput } from '@common-fe/common-fe';

import { LockboxActiveType, LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const LockboxAmountInput = () => {
  const { editableLockbox, originalLockbox, validationErrors, setEditableLockbox } = useLockboxDetailsStore();

  const handleUpdateLockboxAmount = useCallback((amount: string) => {
    setEditableLockbox({ amount });
  }, [setEditableLockbox]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.AMOUNT_REQUIRED
    || error === LockboxValidationError.AMOUNT_EXCEEDS_AVAILABLE_BALANCE) as LockboxValidationError | undefined;
  }, [validationErrors]);

  return (
    <Box>
      <PriceInput
        testId="lockbox-amount"
        name="lockboxAmountInput"
        value={editableLockbox?.amount || ''}
        onChange={handleUpdateLockboxAmount}
        placeholder="Amount"
        {...errorType ? { errorText: lockboxValidationErrorTitle?.[errorType] } : {}}
        disabled={editableLockbox?.liquidateAllFunds || originalLockbox?.archiveType === LockboxActiveType.PAYMENT}
        isSmall
        isBold
      />
    </Box>
  );
};

export default LockboxAmountInput;
